<template lang="pug">
  
	div.legenda-icon
		div.legenda-icon-mapa

			div.legenda-icon-polygon(v-if="!possuiMapa")
			div.legenda-icon-disabled(v-if="!possuiMapa")

			template(v-if="possuiMapa && !isMultiEstilos")
				div.legenda-icon-polygon(v-if="tipoGeometria.codigo === 'POLYGON'", :style="styles")

				div.legenda-icon-point(v-if="tipoGeometria.codigo === 'POINT'", :style="styles")

				div.legenda-icon-linestring(v-if="tipoGeometria.codigo === 'LINESTRING'", :style="styles")
			
			div.legenda-icon-multi(v-if="possuiMapa && isMultiEstilos")
				div.legenda-icon-multi-item.legenda-icon-polygon(v-if="tipoGeometria.codigo === 'POLYGON'")
				div.legenda-icon-multi-item.legenda-icon-polygon(v-if="tipoGeometria.codigo === 'POLYGON'")
				div.legenda-icon-multi-item.legenda-icon-polygon(v-if="tipoGeometria.codigo === 'POLYGON'")

				div.legenda-icon-multi-item.legenda-icon-point(v-if="tipoGeometria.codigo === 'POINT'")
				div.legenda-icon-multi-item.legenda-icon-point(v-if="tipoGeometria.codigo === 'POINT'")
				div.legenda-icon-multi-item.legenda-icon-point(v-if="tipoGeometria.codigo === 'POINT'")


				div.legenda-icon-multi-item.legenda-icon-linestring(v-if="tipoGeometria.codigo === 'LINESTRING'")
				div.legenda-icon-multi-item.legenda-icon-linestring(v-if="tipoGeometria.codigo === 'LINESTRING'")
				div.legenda-icon-multi-item.legenda-icon-linestring(v-if="tipoGeometria.codigo === 'LINESTRING'")

		div.legenda-icon-marcador
			div.beautify-marker.marker(v-if="!possuiMarcador")
			div.legenda-icon-disabled(v-if="!possuiMarcador")

			div.beautify-marker.marker(v-if="possuiMarcador && !isMultiEstilos", 
					:style="{ 'background-color': estilo.marcador.cor }")
			
			div.legenda-icon-multi(v-if="possuiMarcador && isMultiEstilos")
				div.legenda-icon-multi-item.beautify-marker.marker
				div.legenda-icon-multi-item.beautify-marker.marker
				div.legenda-icon-multi-item.beautify-marker.marker

</template>

<script>

export default {
	name: 'IconeLegenda',

	props: {
		estilo: Object,
		camada: Object,
		estilosPersonalizados: Array
	},

	methods: {

		hexToRgba (hex, opacity) {

			var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			
			if (!rgb) return 'rgba(0,0,0,0)';

			return 'rgba(' + parseInt(rgb[1], 16) + ',' +
				parseInt(rgb[2], 16) + ',' +
				parseInt(rgb[3], 16) + ',' +
				opacity + ')';
		},

		getCssEstilo (estilo) {
			var contorno = estilo.contorno;
			var preenchimento = estilo.preenchimento;

			var style = {
				'border-width': contorno ? '1px' : '0',
				'border-color': contorno && this.hexToRgba(contorno.cor, contorno.opacidade),
				'background-color': (preenchimento && this.hexToRgba(preenchimento.cor, preenchimento.opacidade)) || 'rgba(0, 0, 0, 0)'
			};

			return style;
		}
	},

	computed: {

		isMultiEstilos () {
			return this.estilosPersonalizados && this.estilosPersonalizados.length > 0;
		},

		styles () {
			return !this.isMultiEstilos && this.getCssEstilo(this.estilo);
		},

		tipoGeometria () {
			return this.camada.tipoGeometria;
		},

		possuiMarcador () {

			if (this.isMultiEstilos) return this.camada.visualizacao.marcador;

			return !!this.estilo.marcador;
		},

		possuiMapa () {

			if (this.isMultiEstilos) return this.camada.visualizacao.mapa;

			return this.estilo.contorno || this.estilo.preenchimento;
		}
	}
};

</script>

<style lang="scss">

@import "../../styles/variaveis";
@import "../../styles/mixins";

$legenda-icon-inner-size: $legenda-icon-size - 4px;
$legenda-icon-multi-padding: 2px;
$legenda-icon-point-size: floor($legenda-icon-inner-size * 0.7);
$legenda-icon-point-margin: ($legenda-icon-inner-size - $legenda-icon-point-size) / 2;
$legenda-icon-mapa-size: $legenda-icon-inner-size + (2 * $legenda-icon-multi-padding);
$legenda-icon-marcador-size: $legenda-icon-mapa-size;

.legenda-icon {
	display: block;
	float: left;
	width: $legenda-icon-mapa-size + $legenda-icon-marcador-size + 5px;

	.legenda-icon-mapa {
		
		box-sizing: border-box;
		width: $legenda-icon-mapa-size;
		height: $legenda-icon-mapa-size;
		padding: $legenda-icon-multi-padding;
		padding-left: $legenda-icon-multi-padding;
		display: block;
		float: left;
		position: relative;
		
		.legenda-icon-polygon {
			width: 100%;
			height: 100%;
			border-width: 1px;
			border-style: solid;
			@include border-radius(2px);
			border-color: $legenda-icon-disable-color;
			background-color: $legenda-icon-disable-color;
		}

		.legenda-icon-point {
			@include border-radius(50%);
			width: $legenda-icon-point-size;
			height: $legenda-icon-point-size;
			border-width: 1px;
			border-style: solid;
			position: absolute;
			margin-left: $legenda-icon-point-margin;
			margin-top: $legenda-icon-point-margin; 
		}

		.legenda-icon-linestring {
			@include rotate(45deg);
			@include border-radius(2px);
			width: 0px;
			height: 100%;
			border-width: 1px;
			border-style: solid;
			margin-left: 40%;
		}

		& > i.fa {
			font-size: $camadas-nome-fonte-size;
			margin-left: ($legenda-icon-inner-size - $camadas-nome-fonte-size) / 2;
		}
	}

	.legenda-icon-marcador {
		width: $legenda-icon-marcador-size;
		display: block;
		float: left;
		position: relative;
		height: $legenda-icon-mapa-size;

		.legenda-icon-disabled {
			left: 10px;
		}
		.beautify-marker.marker {
			border-top-left-radius: 50%;
			border-top-right-radius: 50% 100%;
			border-bottom-left-radius: 100% 50%;
			border-bottom-right-radius: 0%;
			transform: rotate(45deg);
			width: $legenda-icon-inner-size;
			height: $legenda-icon-inner-size;
			margin-top: $legenda-icon-multi-padding;
			margin-left: 5px;
			background-color: $legenda-icon-disable-color;
		}
	}

	.legenda-icon-multi {
		width: 100%;
		height: 100%;
		position: relative;
			

		.legenda-icon-multi-item {

			border-width: 1px;
			border-color: $legenda-icon-multi-secondary-color;
			background-color: $legenda-icon-multi-primary-color;
			@include box-shadow(1px, 1px, 0, #FFF);
			position: absolute;
			z-index: 3;
			top: -$legenda-icon-multi-padding;
			left: -$legenda-icon-multi-padding;

			& + .legenda-icon-multi-item {
				z-index: 2;
				top: 0;
				left: 0;

				& + .legenda-icon-multi-item {
					top: $legenda-icon-multi-padding;
					left: $legenda-icon-multi-padding;
					z-index: 1;
				}
			}
		}

		.beautify-marker.marker {
			background-color: $legenda-icon-multi-secondary-color;

			& + .beautify-marker.marker {
				background-color: $legenda-icon-multi-primary-color;
			}
		}
	}

	.legenda-icon-disabled {
			@include rotate(-45deg);
			width: 0px;
			border: solid 1px #FFF;
			position: absolute;
			left: 42%;			
			top: 0;
			bottom: 0;
			right: 0;
			z-index: 2;
		}
}
</style>




// WEBPACK FOOTER //
// IconeLegenda.vue?11ae3160